// Field 3.0

export enum FieldType {
    ADDRESS                             = 'address',
    ATTACHMENT                          = 'attachment',
    ATTACHMENTS                         = 'attachments',
    STRING                              = 'string',
    TEXT                                = 'textarea',
    TEXT_WITH_VARIABLES                 = 'text-with-variables',
    PASSWORD                            = 'password',
    DROPDOWN                            = 'dropdown',
    MULTISELECT                         = 'multiselect',
    INTERNAL_DB                         = 'internal-db',
    RADIOGROUP                          = 'radiogroup',
    ICON                                = 'icon',
    COLOR                               = 'color',
    USER                                = 'user',
    USER_REPORTS_TO                     = 'user-reports-to',
    USERS                               = 'users',
    USER_AND_DELETED                    = 'user-and-deleted',
    VIEW_FOR_USER                       = 'view-for-user',
    DEPARTMENT                          = 'department',
    ASSIGNEES                           = 'assignees',
    PHONE                               = 'phone',
    EMAIL                               = 'email',
    URL                                 = 'url',
    CHECKBOX                            = 'checkbox',
    TOGGLE                              = 'toggle',
    NUMBER                              = 'number',
    CURRENCY                            = 'currency',
    PERCENTAGE                          = 'percentage',
    DATE                                = 'date',
    DATE_AND_TIME                       = 'date-and-time',
    DATE_RELATIVE                       = 'date-relative',
    MOMENT                              = 'moment',
    DATE_RANGE                          = 'date-range',
    DATE_RANGE_RELATIVE                 = 'date-range-relative',
    DATE_RANGE_RELATIVE_PERIOD          = 'date-range-relative-period',
    DATE_START_DUE                      = 'date-start-due',
    RATING                              = 'rating',
    RAG                                 = 'rag',
    FORMULA                             = 'formula',
    PROJECTS                            = 'projects',       // multiple projects selector
    TAGS                                = 'tags',
    SELECT_FIELD                        = 'select-field',
    SELECT_FIELDS                       = 'select-fields',
    SELECT_ENTITY_FIELD                 = 'select-entity-field',
    SELECT_GROUP_FIELD                  = 'select-group-field',
    SELECT_VIEW                         = 'select-view',
    STORY_POINTS                        = 'story-points',


    // TIME                                = 'time',   // quick task view - icon + title // DEPRECATED - use time only ?
    TIME_OF_DAY                         = 'time-of-day',   // Value = moment (!) we set date but modify time only
    TIME_DURATION                       = 'time-duration',
    TIME_SPENT                          = 'time-spent',
    COPY_CONTENT                        = 'copy-content', // chto eto za takoe ???
    KEYBOARD_SHORTCUT                   = 'keyboard-shortcut',
    MESSAGES_TOTAL                      = 'messages-total',
    ICON_WITH_COLOR                     = 'icon-with-color',
    PREDECESSORS                        = 'predecessors',
    SUCCESSORS                          = 'successors',
    TEMPLATE_PARENT                     = 'template-parent',
    BREAK_DURATION                      = 'break-duration', // generic ??? stupid name ....
    REACTION                            = 'reaction',
    VOTING                              = 'voting',
    MULTISELECT_CHECKBOX                = 'multiselect-checkbox',
    STEPPER                             = 'stepper',
    LOCATION                            = 'location',
    SKILLS                              = 'skills',

    // ENTITIES
    PROJECT                             = 'project',    // i.e. parent
    PROJECT_PATH                        = 'project-path',   // ???
    TASK                                = 'task',   // quick task view - icon + title
    REMINDER                            = 'reminder',
    EVENT                               = 'event',
    MEETING                             = 'meeting',

    // ITEM MODEL
    ITEM_MODEL_STORY_POINTS_CALCULATED  = 'item-model-story-points-calculated',
    ITEM_MODEL_CALCULATED_TIME_REPORTS  = 'item-model-calculated-time-reports',
    ITEM_MODEL_CALCULATED_EXPENSES      = 'item-model-calculated-expenses',
    ITEM_MODEL_CALCULATED_ESTIMATE      = 'item-model-calculated-estimate',
    ITEM_MODEL_CALCULATED_SPENT_ESTIMATE= 'item-model-calculated-spent-estimate',
    ITEM_MODEL_CALCULATED_LABOR_COST    = 'item-model-calculated-labor-cost',
    ITEM_MODEL_CALCULATED_SERVICE_COST  = 'item-model-calculated-service-cost',

    // TASK
    TASK_ID                             = 'task-id',
    TASK_TITLE                          = 'task-title',
    TASK_TYPE                           = 'task-type',
    TASK_TYPE_ICON                      = 'task-type-icon',
    TASK_TYPES                          = 'task-types', // use it where u need to select multiple task types
    TASK_PROJECT                        = 'task-project',
    TASK_PARENT_TASK                    = 'task-parent-task',
    TASK_STATUS                         = 'task-status',
    TASK_STATUS_CHANGED                 = 'task-status-changed',
    TASK_SYSTEM_STATUS                  = 'task-system-status',
    TASK_PRIORITY                       = 'task-priority',
    TASK_STORY_POINTS                   = 'task-story-points',
    TASK_ACTION_REQUIRED                = 'task-action-required',
    TASK_ASSIGNED_TO                    = 'task-assigned-to',
    TASK_TIME_REPORTED                  = 'task-time-reported',
    TASK_ESTIMATE                       = 'task-estimate',
    TASK_PROGRESS                       = 'task-progress',
    TASK_PROGRESS_ITEMS                 = 'task-progress-items',
    TASK_DESCRIPTION                    = 'task-description',
    TASK_DESCRIPTION_EDITOR             = 'task-description-editor',
    TASK_START_END                      = 'task-start-end',
    TASK_LATEST_ACTIVITY_MOMENT         = 'task-latest-activity-moment',
    TASK_PREDECESSOR_TASKS              = 'task-predecessor-tasks',  // used in import only
    TASK_DEADLINE                       = 'task-deadline',
    TASK_START_DATE                     = 'task-start-date',
    TASK_END_DATE                       = 'task-end-date',
    TASK_SCHEDULE                       = 'task-schedule',
    TASK_DURATION_WORKDAYS              = 'task-duration-workdays',
    TASK_DURATION_CALENDAR              = 'task-duration-calendar',
    TASK_CREATED_BY                     = 'task-created',
    TASK_MOMENT_CREATED                 = 'task-moment-created',
    TASK_MOMENT_CLOSED                  = 'task-moment-closed',
    TASK_USERS                          = 'task-users',
    TASK_REPORTED_BY_USERS              = 'task-reported-by-users',
    TASK_TAGS                           = 'tags',
    TASK_LEAD_TIME                      = 'task-lead-time',
    TASK_AGE                            = 'task-age',
    TASK_COUNTER                        = 'task-counter',
    TASK_TODO_LIST                      = 'task-todo-list',
    TASK_COVER                          = 'task-cover',
    TASK_SELECT                         = 'task-select',

    // PROJECT
    PROJECT_NAME                        = 'project-name',
    PROJECT_STATUS                      = 'project-status',
    PROJECT_SYSTEM_STATUS               = 'project-system-status',  // used for folders, tags ?
    PROJECT_OWNER                       = 'project-owner',
    PROJECT_ACCESS                      = 'project-access',
    PROJECT_ACCESS_MULTISELECT          = 'project-access-multiselect',
    PROJECT_ACCESS_MODE                 = 'project-access-mode',
    PROJECT_ICON                        = 'project-icon',
    PROJECT_HEALTH                      = 'project-health',
    PROJECT_PARENT                      = 'project-parent',
    PROJECT_TYPE                        = 'project-type',
    PROJECT_PRIORITY                    = 'project-priority',
    PROJECT_ESTIMATE                    = 'project-estimate',
    PROJECT_ESTIMATE_TASKS              = 'project-estimate-tasks',
    PROJECT_PROGRESS                    = 'project-progress',
    PROJECT_TEMPLATE                    = 'project-template',
    PROJECT_USERS                       = 'project-users',
    PROJECT_REPORTED_BY_USERS           = 'project-reported-by-users',
    PROJECT_START                       = 'project-start',
    PROJECT_END                         = 'project-end',
    PROJECT_START_END                   = 'project-start-end',
    PROJECT_DEADLINE                    = 'project-deadline',
    PROJECT_MOMENT_CREATED              = 'project-moment-created',
    PROJECT_DURATION_WORKDAYS           = 'project-duration-workdays',
    PROJECT_DURATION_CALENDAR           = 'project-duration-calendar',
    PROJECT_PROGRESS_ITEMS              = 'project-progress-items',
    PROJECT_TOTAL_OPEN_ALL              = 'project-total-open-all',
    PROJECT_COLOR                       = 'project-color',
    PROJECT_PROGRESS_TASKS              = 'project-progress-tasks',
    PROJECT_COLOR_ICON                  = 'project-color-icon',

    // WORKSPACE
    WORKSPACE_ACCESS                    = 'workspace-access',

    // CRM
    CRM_ACCOUNT                         = 'crm-account',
    CRM_CONTACT                         = 'crm-contact',
    CRM_CONTACTS                        = 'crm-contacts',
    CRM_CONTACT_TYPE                    = 'crm-contact-type',
    CRM_CONTACTS_TOTAL                  = 'crm-contacts-total',

    // AUTOMATION
    AUTOMATION_TRIGGER_TYPE             = 'automation-trigger-type',
    AUTOMATION_CONDITION_TYPE           = 'automation-condition-type',
    AUTOMATION_ACTION_TYPE              = 'automation-action-type',
    AUTOMATION_STATUS_MULTISELECT       = 'automation-status-multiselect',
    AUTOMATION_STATUS_DROPDOWN          = 'automation-status-dropdown',
    AUTOMATION_USER_MULTISELECT         = 'automation-user-multiselect',
    AUTOMATION_USER_DROPDOWN            = 'automation-user-dropdown',
    AUTOMATION_MESSAGE                  = 'automation-message',
    AUTOMATION_PRIORITY_MULTISELECT     = 'automation-priority-multiselect',
    AUTOMATION_PRIORITY_DROPDOWN        = 'automation-priority-dropdown',

    // EVENT
    EVENT_START                         = 'event-start',
    EVENT_END                           = 'event-end',
    EVENT_START_END                     = 'event-start-end',
    EVENT_PARENT                        = 'event-parent',
    EVENT_STATUS                        = 'event-status',
    EVENT_ASSIGNED_USER                 = 'event-assigned-user',
    EVENT_TYPE                          = 'event-type',
    EVENT_TYPES                         = 'event-types',
    EVENT_DURATION_WORKDAYS             = 'event-duration-workdays',
    EVENT_DURATION_CALENDAR             = 'event-duration-calendar',

    // GROUP
    GROUP_STATUS                        = 'group-status',   // is used for group table cell view
    GROUP_ESTIMATE                      = 'group-estimate', // is extended for group table cell view
    GROUP_NUMBER_OF_TASKS               = 'group-number-of-tasks', // is used for board aggregation
    GROUP_REPORTED_BY_USERS             = 'group-reported-by-users',

    // DOCUMENTS
    DOCUMENT_TYPE                       = 'document-type',
    DOCUMENT_ACCESS_READ                = 'document-access-read',
    DOCUMENT_ACCESS_WRITE               = 'document-access-write',

    // TO-DO LIST TEMPLATE
    TODO_LIST_TEMPLATE                  = 'todo-list-template',

    // SYSTEM LOG
    SYSTEM_LOG_STATUS                   = 'system-log-status',

    // AGILE
    AGILE_REPORT_DATE                   = 'agile-report-date',

    // COMPANY USER
    COMPANY_USER_ROLE                   = 'company-user-role',
    COMPANY_USER_WORKDAY_DURATION       = 'company-user-workday-duration',
    COMPANY_USER_REQUIRED_REPORT_TIME   = 'company-user-required-report-time',
    COMPANY_USER_SKILLS                 = 'company-user-skills',
    COMPANY_USER_WORK_SCHEDULE          = 'company-user-work-schedule',

    // GANTT BASELINE
    BASELINE                            = 'baseline',

    // Cost
    COST_INTERNAL                       = 'cost-internal',
    COST_EXTERNAL                       = 'cost-external',
    ESTIMATED_COST_INTERNAL             = 'estimated-cost-internal',    // estimated time * rate
    ESTIMATED_COST_EXTERNAL             = 'estimated-cost-external',    // estimated time * rate
    ATTACHMENTS_TOTAL                   = 'attachments-total',

    // Expenses
    EXPENSE_NAME                        = 'expense-name',
    EXPENSE_CATEGORY                    = 'expense-category',
    EXPENSE_PROJECT                     = 'expense-project',
    EXPENSE_APPROVAL_STATUS             = 'expense-approval-status',
    EXPENSE_REIMBURSEMENT               = 'expense-reimbursement',
    EXPENSE_AMOUNT                      = 'expense-amount',
    EXPENSE_UNITS                       = 'expense-units',
    EXPENSE_SUBMITTED_ON                = 'expense-submitted-on',
    EXPENSE_DATE                        = 'expense-date',

    // Custom VIEW
    CUSTOM_VIEW_USER_ACCESS             = 'custom-view-user-access',

    // Navigation
    NAVIGATION_DISPLAY_IN               = 'navigation-display-in',

    // Time Report fields
    TIME_REPORT_USER                    = 'time-report-user',
    TIME_REPORT_DATE                    = 'time-report-date',
    TIME_REPORT_IS_BILLABLE             = 'time-report-is-billable',
    TIME_REPORT_ENTITY                  = 'time-report-item',
    TIME_REPORT_MINUTES                 = 'time-report-minutes',
    TIME_REPORT_MESSAGE                 = 'time-report-message',
    TIME_REPORT_TIME_OF_DAY             = 'time-report-time-of-day',
    TIME_REPORT_PROJECT                 = 'time-report-project',
    TIME_REPORT_ACTIVITY_TYPE           = 'time-report-activity-type',
    TIME_REPORT_TITLE                   = 'time-report-title',
    TIME_REPORT_ID                      = 'time-report-id',
    TIME_REPORT_TASK_ID                 = 'time-report-task-id',

    // Goals
    GOAL_HEALTH                         = 'goal-health',
    GOAL_TYPE                           = 'goal-type',
    GOAL_ASSIGNEES                      = 'goal-assignees',
    GOAL_ICON                           = 'goal-icon',

    // Public forms & requests
    REQUEST_FORM_PARENT                 = 'requests-and-forms',
    REQUEST_FORM_SELECT                 = 'request-form-select',

    // Webhooks v2 — destination picker for the send-webhook action
    WEBHOOK_SELECT                      = 'webhook-select',

    COMPANY_OFFICE                      = 'office',
    EDIT_DURATION                       = 'edit-duration',  // chto eto za fignya eto system ? kakoi Entity otnositsya ? net v nazvanii...
}
